import React from 'react'

import mercadoLibre from './mercadolibre.svg'
import google from './google.svg'
import dataart from './dataart.png'
import virtualmind from './virtualmind.png'
import stensul from './stensul.svg'
import acamica from './acamica.png'
import olx from './olx.png'
import mozilla from './mozilla.png'

const Sponsors = ({className}) => (
  <div className={`sponsors ${className}`} id="sponsors">
    <h2>Sponsors</h2>
    <div className="sponsors-gold">
      <a href="https://jobs.mercadolibre.com/?locale=es_ES" target="_blank" className="sponsors-gold_item">
        <img src={mercadoLibre} alt="Mercado Libre" />
      </a>
      <div className="sponsors-gold_item">
        <img src={google} alt="Google" />
      </div>
      <div className="sponsors-gold_item">
        <div className="sponsors-join">
          <p className="sponsors-join_text">
            Interested in sponsoring us?
            <a className="sponsors-join_link" href="mailto:info@cssconfar.com">Let’s talk!</a>
          </p>
        </div>
      </div>
    </div>
    <div className="sponsors-silver">
      <a href="https://www.dataart.com.ar/" target="_blank" className="sponsors-silver_item">
        <img src={dataart} alt="DataArt" />
      </a>
      <a href="https://www.virtualmind.io/" target="_blank" className="sponsors-silver_item">
        <img src={virtualmind} alt="Virtualmind" />
      </a>
      <a href="https://stensul.com/" target="_blank" className="sponsors-silver_item">
        <img src={stensul} alt="Stensul" />
      </a>
      <a href="https://www.acamica.com/" target="_blank" className="sponsors-silver_item">
        <img src={acamica} alt="Acamica" />
      </a>
      <a href="https://olxgroup.com/search/all-functions/argentina-buenos-aires/all-brands" target="_blank" className="sponsors-silver_item">
        <img src={olx} alt="OLX" />
      </a>
    </div>
    <div className="sponsors-bronze">
      <div className="sponsors-bronze_item">
        <img src={mozilla} alt="Mozilla" />
      </div>
    </div>
  </div>
)

Sponsors.defaultProps = {
  className: ""
}

export default Sponsors



// WEBPACK FOOTER //
// ./src/components/Sponsors/index.js